import React from 'react';
import { motion } from 'framer-motion';
import { lenderVariants, screens } from '../data/withdraw';
import { LenderVariant, ScreenId } from '../types/withdraw';
interface ScreenSwitcherProps {
  active: ScreenId;
  onChange: (screen: ScreenId) => void;
  lenderVariant: LenderVariant;
  onLenderVariantChange: (variant: LenderVariant) => void;
}
const spring = {
  type: 'spring' as const,
  stiffness: 500,
  damping: 38
};
export function ScreenSwitcher({
  active,
  onChange,
  lenderVariant,
  onLenderVariantChange
}: ScreenSwitcherProps) {
  return <nav aria-label="Review states" className="fixed bottom-4 left-1/2 z-50 flex max-w-[calc(100%-2rem)] -translate-x-1/2 items-center gap-2 overflow-x-auto rounded-full bg-slate-900/85 p-1 text-[11px] font-semibold text-slate-300 shadow-lift ring-1 ring-white/10 backdrop-blur" data-id="element-5" data-mp="jz9g19i58dxa">
      <span className="pl-2.5 pr-0.5 text-slate-400" data-id="element-6" data-mp="3sejkgo9i9v88">Review</span>
      <div className="flex items-center gap-0.5" data-id="element-7" data-mp="16f992uobs45">
        {screens.map((s, i) => {
        const isActive = s.id === active;
        return <button key={s.id} type="button" onClick={() => onChange(s.id)} aria-current={isActive ? 'step' : undefined} className={`relative whitespace-nowrap rounded-full px-2.5 py-1 transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-300 ${isActive ? 'text-slate-900' : 'hover:text-white'}`} data-id="element-8" data-mp="2bblw3myromz8" data-mpi={i}>
              {isActive && <motion.span layoutId="review-screen-pill" className="absolute inset-0 rounded-full bg-white" transition={spring} data-id="element-9" data-mp="1nm1aewb8bbm9" />}
              <span className="relative" data-id="element-10" data-mp="1wkwea1qsw9me">
                {i + 1}. {s.label}
              </span>
            </button>;
      })}
      </div>
      <span className="h-4 w-px shrink-0 bg-white/15" aria-hidden="true" data-id="element-11" data-mp="18tzd9k0jmwpx" />
      <div role="radiogroup" aria-label="Lender type" className="flex items-center gap-0.5 pr-0.5" data-id="element-12" data-mp="14ui7eph7fxk8">
        {lenderVariants.map(v => {
        const isActive = v.id === lenderVariant;
        return <button key={v.id} type="button" role="radio" aria-checked={isActive} onClick={() => onLenderVariantChange(v.id)} className={`relative whitespace-nowrap rounded-full px-2.5 py-1 transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-300 ${isActive ? 'text-white' : 'hover:text-white'}`} data-id="element-13" data-mp="38wi8yj1hqk8r">
              {isActive && <motion.span layoutId="review-lender-pill" className="absolute inset-0 rounded-full bg-primary-700" transition={spring} data-id="element-14" data-mp="2uwqwimqmhbwv" />}
              <span className="relative" data-id="element-15" data-mp="2zuset5g8577a">{v.label}</span>
            </button>;
      })}
      </div>
    </nav>;
}